// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"9c782ea0","387":"0147964f","409":"84427eb9","436":"cf4ca11e","453":"e1ed1f42","598":"c57348b2","678":"51e0b472","819":"a51a98ef","866":"1405d644","892":"b812b29a","896":"1989d72e","951":"2aa0dc0c"}[chunkId] + ".chunk.js";
};